window.popup=function(name1,name2){
    $(".mask").height($(document).height()).show();
    $(name1).show();
    $(".icon-close").click(function(){
        $(".mask ,.ent").hide();
        $(name1).hide();
    });
    if(name2){
        $(".ent").eq(name2).show()
    }

};